import { ISipCause } from '../../shared/models/sip-cause.model';
import { IFundraiser } from '../../fundraiser/models/fundraiser.model';
import { IUser } from '../../shared/models';
import { ICart } from '../payment/models/cart.model';
import { IContribute } from '../payment/models/contribute.model';

export interface IPaymentSipConfig {
  amount?: number;
  labelAmount?: number;
  cart_amount?: number;
  auto_pay_m1?: number;
  afterAmountLabel?: string;
  beforeAmountLabel?: string;
  campaign_id?: number;
  cart?: ICart;
  buttonId?: string;
  childCount?: boolean;
  frtip?: boolean;
  currency?: string;
  dialogBtnLabel?: string;
  dialogBtnSkipFailed?: boolean;
  dialogBtnTheme?: string;
  disableCard?: boolean;
  donateBtnLabel?: string;
  enable_multicause_slection?: boolean;
  enable_multicause_slab?: boolean;
  enable_person_based_amount?: boolean;
  enableMaintenanceFee?: boolean;
  formImg?: string;
  formNote?: boolean;
  formTheme?: string;
  frequency_term?: string;
  frequency?: number;
  frequency_slabs?: IFrequencySlabs;
  fundraiser?: IFundraiser;
  hideCaptchaNote?: boolean;
  hideCardInfo?: boolean;
  hideDockBtn?: boolean;
  showFeeNudge?: boolean;
  hideNote?: boolean;
  hideRecommendedNote?: boolean;
  hideSipDonors?: boolean;
  label?: string;
  theme?: string;
  last_pay_mode?: string;
  lastOrder?: {
    iso_currency: string,
    payment_details?: {
      customer_id: string,
      last4: string
    },
    payment_gateway: string,
    payment_mode: string,
    payment_mode_value: string,
    upi_id: string
  };
  minAmount?: boolean;
  month_interval?: number;
  tenure?: number;
  ngo_sip?: number;
  nonRecommended?: IRecomended;
  one_tap_pay?: boolean;
  one_time_donation?: boolean;
  optionTabs?: IOptionsSipTab[];
  optionsCheck?: boolean;
  optionTabsOnetime?: IOptionsSipTab[];
  otherAmountTheme?: string;
  other_label_text?: string;
  origin?: string;
  onpage?: boolean;
  order?: any;
  onAmtForm?: any;
  page?: string;
  payment_method_change?: any;
  paymentDetails?: IContribute;
  paymentOptions?: {
    gateway: string,
    options: any,
    setting: any
  };
  paymentOptionsTitle?: string;
  payType?: string;
  plan?: string;
  pledge_more?: number;
  popular_slab_text?: string;
  recommended?: IRecomended;
  recommendedTab?: string;
  redirectTo?: string;
  selectedTab?: IOptionsSipTab;
  selectEmandateBank?: boolean;
  show_one_tap_otp?: boolean;
  show_popular_slab?: boolean;
  show_popular_tip?: boolean;
  show_start_date?: boolean;
  showCardInfoBottom?: boolean;
  showDock?: boolean;
  showEmandateBankOnly?: boolean;
  showOfferTag?: boolean;
  showOptionBackBtn?: boolean;
  showPaySwitch?: boolean;
  showSlabRecommended?: boolean;
  showSlabRecommendedText?: string;
  showTopBank?: boolean;
  showTutorial?: boolean;
  showVerifiedBy?: boolean;
  showExtraInfo?: boolean;
  showOtherAmount?: boolean;
  sip_cause?: ISipCause[];
  sip_story?: boolean;
  sip_wallet?: number; // 1=wallet enable, 0=strictly disable wallet
  min_donation?: number;
  slabsPostLabel?: string;
  slabTheme?: string;
  subscription_id?: number;
  subtile?: string;
  supported_cards?: any;
  systemEvent?: ISystemEvent;
  themeColor?: string;
  title?: string;
  trialbased_donation?: number;
  user?: IUser;
  visibleTabs?: IOptionsSipTab[];
  wallet_recharge?: number;
  wallet_tenure?: number;
  wallet_to_autopay?: number;
  inputAppearance?: string;
  cardTheme?: string;
  paymentBtnClass?: string;
  showUpiIntent?: boolean;
  isQR?: any;
  upiMode?: {
    mode: string,
    value: string
  };
  sipCause?: string;
  showBeneficiary?: boolean;
  recentPayMode?: {
    payment_mode: string,
    payment_mode_value: string
  };
  showTip?: boolean;
  showSlabs?: boolean;
  tipAmount?: number;
  tip_only?: boolean;
  donatingAs?: boolean;
  showTipCard?: boolean;
  showOneReChangePay?: boolean;
}


export interface IOptionsSipTab {
  icon: string;
  label: string;
  mode: string;
  name: string;
  note: string;
  order_mode: string;
  recommended: boolean;
  selected: boolean;
  show: boolean;
  tabs?: string[];
}

interface IRecomended {
  label?: string;
  preferred_icon: string;
  preferred_text: string;
}

interface ISystemEvent {
  eventName?: string;
  info_1?: string;
  info_2?: string;
  info_3?: string;
  info_4?: string;
}

export interface IFrequencySlabs {
  type?: string;
  slab_theme?: string;
  slabs?: any[];
  default_selected?: number;
  recommended_slab?: number;
  min?: number;
  max?: number;
  show_popular_slab?: boolean;
  pre_label?: string;
  post_label?: string;
  hide_manual_input?: boolean;
  manual_input_label?: string;
  hide_item_text?: boolean;
}


export const SIP_PAYMENT_DEFAULT_CONFIG: IPaymentSipConfig = {
  childCount: false,
  currency: '',
  disableCard: false,
  formImg: '', // e.g /assets/images/portfolio/holding-hand-sketch.png
  formNote: false,
  formTheme: '', // e.g form-theme-v1
  hideNote: false,
  origin: 'sps',
  paymentOptionsTitle: 'Please select your payment mode',
  payType: 'auto_pay',
  recommendedTab: 'bank',
  redirectTo: '',
  selectEmandateBank: true,
  showTopBank: false,
  showTutorial: true,
  sip_wallet: null,
  slabsPostLabel: 'per month',
  slabTheme: 'slab-theme-v1',
  subtile: '', // e.g With as little as <strong>₹100</strong> monthly, you can give underprivileged kids a second chance at life
  supported_cards: ['VISA', 'MASTER', 'MX', 'MAESTRO', 'RUPAY'],
  themeColor: '#01bfbd',
  title: '', // e.g Continue Doing Good Deeds
  wallet_tenure: 6,
  nonRecommended: {
    preferred_icon: 'icon-idea-bulb',
    preferred_text: 'To ensure successful recurring payments, we recommend you to use'
  },
  paymentBtnClass: 'payment-btn-theme-v1',
  showUpiIntent: true,
  showSlabs: true,
  showTip: false,
  showOneReChangePay: false,
  optionTabs: [
    {
      show: true,
      name: 'bank',
      label: 'Net Banking',
      icon: 'icon-bank',
      recommended: false,
      selected: false,
      note: `This Account will be linked to a monthly subscription and future payments will be charged automatically. On clicking the 'Pledge' button you will be redirected to the NPCI platform.`,
      mode: 'Emandate',
      order_mode: 'Emandate',
      tabs: ['Emandate', 'CARD']
    },
    {
      show: true,
      name: 'card',
      label: 'Credit Card',
      icon: 'icon-cards',
      recommended: false,
      selected: false,
      note: `This card will be linked to the subscription and future payments will be charged automatically. On clicking "Pledge" button you might be taken to your bank's website for 3D secure authentication.`,
      mode: 'CARD',
      order_mode: 'CARD',
      tabs: []
    },
    {
      show: true,
      name: 'wallet',
      label: 'Wallet',
      icon: 'icon-wallet',
      recommended: false,
      selected: false,
      note: `This wallet account will be linked to the subscription and future payments will be charged automatically. On clicking "Pledge" button you might be taken to Paytm's website.`,
      mode: 'WALLET_RECURRING',
      order_mode: 'WALLET_RECURRING',
      tabs: []
    },
    {
      show: true,
      name: 'upi',
      label: 'UPI',
      icon: 'icon-upi',
      recommended: false,
      selected: false,
      note: `This Account will be linked to the subscription and future payments will be charged automatically. On clicking "Pledge" button you will be redirected to the UPI app.`,
      mode: 'UPIRECURRING',
      order_mode: 'UPIRECURRING',
      tabs: []
    }
  ],
  optionTabsOnetime: [
    {
      show: true,
      name: 'bank',
      label: 'Net Banking',
      icon: 'icon-bank',
      recommended: false,
      selected: false,
      note: '',
      mode: 'NB',
      order_mode: 'NB',
      tabs: ['Emandate']
    },
    {
      show: true,
      name: 'card',
      label: 'Credit Card',
      icon: 'icon-cards',
      recommended: false,
      selected: false,
      note: '',
      mode: 'CARD',
      order_mode: 'CARD',
      tabs: []
    },
    {
      show: true,
      name: 'wallet',
      label: 'Wallet',
      icon: 'icon-wallet',
      recommended: false,
      selected: false,
      note: '',
      mode: 'TOPWALLET',
      order_mode: 'WALLET',
      tabs: []
    },
    {
      show: true,
      name: 'upi',
      label: 'UPI',
      icon: 'icon-upi',
      recommended: false,
      selected: false,
      note: '',
      mode: 'TOPUPI',
      order_mode: 'UPI',
      tabs: []
    }
  ],
  recommended: {
    label: 'Net Banking',
    preferred_icon: 'icon-thumbsup',
    preferred_text: 'Thanks for choosing our preferred mode of payment'
  }
};
